function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const UnarchiveIcon = _ref => {
  let {
    size = 16,
    bg = 'currentColor',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.9 9.9l-4-5c-.2-.2-.5-.3-.7-.1s-.3.5-.1.7l3.9 4.9v.3h-3.5l-2 2h-3l-2-2H1v-.3l3.9-4.9c.2-.2.1-.5-.1-.6s-.5-.2-.7 0l-4 5c-.1.1-.1.2-.1.3v4.5c0 .6.4 1 1 1h14c.6 0 1-.4 1-1v-4.5c0-.1 0-.2-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 .2L4.5 3.8H7v5h2v-5h2.5L8 .2z"
  }));
};
export default UnarchiveIcon;